import React, {useEffect, useState } from 'react';
import Units from './PopupUnits';
import Recipe from './PopupRecipe';

const ITEM_MODES ={
  '0': 'None',
  '1': 'VEG',
  '2': 'NON-VEG',
}
export default function InventoryItem() {
  const [openUnitsPopup, setOpenUnitsPopup] = useState(false);
  const [openRecipePopup, setOpenRecipePopup] = useState(false);
  const [editData, setEditData] = useState();
  const [tableData, setTableData] = useState([]);
  const [categories, setCategories] = useState({});

  const close = ()=> {
    setOpenUnitsPopup(false);
    setOpenRecipePopup(false);
  };

  useEffect(() => {
    const getItems = async () => {
      const json = {
        outlet_uuid: localStorage.getItem("outlet_uuid"),
      }
      const url = `https://api.myfooddo.com/item/ListItem`;
      // const url = `http://localhost:5000/item/ListItem`;
      // console.log(url, json)
      await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(json),
      })
      .then(res => res.json())
      .then(data => {
        setTableData(data);
      })
      .catch(err => console.warn("post request failed", err));
    }
    const getCategories = async () => {
      const json = {
        outlet_uuid: localStorage.getItem("outlet_uuid"),
      }
      const url = `https://api.myfooddo.com/category/list`;
      // console.log(url, json)
      await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(json),
      })
      .then(res => res.json())
      .then(data => {
        const dataArr = {};
        if(data.length > 0){
          data.forEach((a)=>{
            dataArr[a.category_uuid]=a.category_name;
          })
        setCategories(dataArr);
        }
      })
      .catch(err => console.warn("post request failed", err));
    }
    getItems();
    getCategories();
  }, [openUnitsPopup, openRecipePopup]);

  const handlePOSInvChange = async (itemId, posInvValue) => {
    if (!itemId) return false;
    const json = {
      item_uuid: itemId,
      outlet_uuid: localStorage.getItem("outlet_uuid"),
      pos_inventory: posInvValue,
    };
    const url = `https://api.myfooddo.com/item/EditPOSInventory`;
    // const url = `http://localhost:5000/item/EditPOSInventory`;
    console.log(url, json)
    await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify(json),
    })
    .then(res => res.json())
    .then(data => { 
      console.log('PutItem...', data)
    })
    .catch(err => console.warn("post request failed", err));
  }

  return (
    <div className="accountGroup">
      <h1>Item</h1>
      
      <div className="topInputs">
        <div className="inputGroup">
          <input type="search" placeholder="Search..." />
        </div>
      </div>
      
      <div className="items_table" style={{height:'fit-content',padding: '0 5px 10px'}}>
        <table className="f6 w-100 center" cellSpacing="0">
          <thead className="lh-copy">
            <tr className="white">
              <th className="pa2 bb pl3 tl b--black-20 ">Sr No.</th>
              <th className="pa2 bb pl3 tl b--black-20 ">Category Name</th>
              <th className="pa2 bb tl b--black-20 ">Item Name</th>
              <th className="pa2 bb b--black-20 ">Item Code</th>
              <th className="pa2 bb b--black-20 ">Item Mode</th>
              <th className="pa2 bb b--black-20 ">Description</th>
              <th className="pa2 bb b--black-20 ">Price</th>
              <th className="pa2 bb b--black-20 ">Tax%</th>
              <th className="pa2 bb b--black-20 ">Action</th>
              <th className="pa2 bb b--black-20 ">POS Inventory</th>
            </tr>
          </thead>
          <tbody className="lh-copy">
            {tableData.length > 0 && tableData?.map((data, i)=>{
              return (data.item_uuid) ?
               <tr key={i.toString()}>
                  <td className="pr2 pv1 pl3 bb b--black-20  bg-white">{i+1}</td>
                  <td className="pr2 pv1 pl3 bb b--black-20  bg-white">{categories[data.category_uuid]}</td>
                  <td className="ph2 pv1 bb b--black-20 bg-white">{data.item_name}</td>
                  <td className="ph2 pv1 bb b--black-20 tc bg-white">{data.outlet_wise_item_details?.find(o=> o.outlet_uuid === localStorage.getItem("outlet_uuid"))?.other_details?.item_code || '-'}</td>
                  <td className="ph2 pv1 bb b--black-20 tc bg-white">{ITEM_MODES[data.item_mode]}</td>
                  <td className="ph2 pv1 bb b--black-20 tc bg-white">{data?.item_description || '-'}</td>
                  <td className="ph2 pv1 bb b--black-20 tc bg-white">{data.outlet_wise_item_details?.find(o=> o.outlet_uuid === localStorage.getItem("outlet_uuid"))?.other_details?.item_vat}</td>
                  <td className="ph2 pv1 bb b--black-20 tc bg-white">{data.outlet_wise_item_details?.find(o=> o.outlet_uuid === localStorage.getItem("outlet_uuid"))?.other_details?.item_gst}</td>
                  <td className="ph2 pv1 bb b--black-20 tc bg-white">
                    <div className="accountGroupOptions" style={{padding:'0', justifyContent: 'center'}}>
                      <div>
                        <button onClick={()=> {
                          setOpenRecipePopup(true);
                          setEditData(data);
                        }}>Recipe</button>

                        <button onClick={()=> {
                          setOpenUnitsPopup(true);
                          setEditData(data);
                        }}>Units</button>
                      </div>
                    </div>
                  </td>
                  <td className="ph2 pv1 bb b--black-20 tc bg-white">
                    <label>
                      <input 
                        type="radio"
                        name={"pos_inventory" + i}
                        value="1"
                        defaultChecked={data.outlet_wise_item_details?.find(o=> o.outlet_uuid === localStorage.getItem("outlet_uuid"))?.pos_inventory === '1'}
                        onChange={e => handlePOSInvChange(data.item_uuid, e.target.value)}
                      /> Yes
                    </label> <label>
                      <input
                        type="radio"
                        name={"pos_inventory" + i}
                        value="0"
                        defaultChecked={data.outlet_wise_item_details?.find(o=> o.outlet_uuid === localStorage.getItem("outlet_uuid"))?.pos_inventory === '0'}
                        onChange={e => handlePOSInvChange(data.item_uuid, e.target.value)}
                      /> No
                    </label>
                  </td>
               </tr>
               : ''
            })}
          </tbody>
        </table>
      </div>
      
      {openUnitsPopup && (
        <Units
          type={!editData? "edit" : "New"}
          close={close}
          value={editData}
        />
      )}
      {openRecipePopup && (
        <Recipe
          type={!editData? "edit" : "New"}
          close={close}
          value={editData}
        />
      )}
    </div>
  )
}

